import { render, staticRenderFns } from "./ShbxGd.vue?vue&type=template&id=119a5e59&scoped=true"
import script from "./ShbxGd.vue?vue&type=script&lang=js"
export * from "./ShbxGd.vue?vue&type=script&lang=js"
import style0 from "./ShbxGd.vue?vue&type=style&index=0&id=119a5e59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a5e59",
  null
  
)

export default component.exports